var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJira = function SvgJira(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#jira_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2684FF",
    d: "M19.114 0H9.508a4.336 4.336 0 0 0 4.336 4.336h1.77v1.708a4.336 4.336 0 0 0 4.333 4.334V.833A.833.833 0 0 0 19.114 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#jira_svg__b)",
    d: "M14.361 4.786H4.756A4.336 4.336 0 0 0 9.089 9.12h1.77v1.714a4.336 4.336 0 0 0 4.336 4.33V5.62a.833.833 0 0 0-.834-.833"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#jira_svg__c)",
    d: "M9.606 9.57H0a4.336 4.336 0 0 0 4.336 4.336h1.775v1.708a4.336 4.336 0 0 0 4.328 4.333v-9.544a.833.833 0 0 0-.833-.834"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "jira_svg__b",
    x1: 1028.09,
    x2: 621.964,
    y1: 6.453,
    y2: 430.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jira_svg__c",
    x1: 1050.83,
    x2: 581.047,
    y1: 14.292,
    y2: 476.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "jira_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgJira;